import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import RentalExportDataXlsx from "components/common/RentalExportExcel";
import HourRentalBasicRateTable from "components/hourRentalBasicRate/HourRentalBasicRateTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import HourRentalBasicRateServices from "services/HourRentalBasicRateServices";
import { FiPlus } from "react-icons/fi";
import HourRentalBasicRateDrawer from "components/drawer/HourRentalBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";

const HourRentalBasicRate = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    HourRentalBasicRateServices.getAllHourRentalBasicRate,
  );
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array
  // console.log("data from safedata", safeData);

  const isAdmin = adminInfo?.id === 1;

  const hideView = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate" && perm.view === 1,
  );

  const hideDelete = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate" && perm.delete === 1,
  );

  const hideEdit = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate" && perm.edit === 1,
  );

  const hideAdd = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate" && perm.add === 1,
  );

  const hideExport = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "basic rate" && perm.export === 1,
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const {
    hourRentalBasicRateRef,
    dataTable,
    serviceData,
    handleSubmitHourRentalBasicRate,
    currentPage,
  } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
  // console.log("data",dataTable);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  // const updatedData = data?.data?.map((item, itemIndex) => {
  //   const vehicleIds = item.vehicle_type_id || [];
  //   const vehicleNames = item.vehicle_type_names || {};

  //   // Combine all vehicle details into newline-separated strings
  //   const vehicleTypes = vehicleIds
  //     .map((vid) => vehicleNames[vid] || vid)
  //     .join(", ");

  //   const h4_40km = vehicleIds
  //     .map((vid) => item["4h_40km"]?.[vid] || "")
  //     .join(", ");

  //   const h6_60km = vehicleIds
  //     .map((vid) => item["6h_60km"]?.[vid] || "")
  //     .join(", ");

  //   const h8_80km = vehicleIds
  //     .map((vid) => item["8h_80km"]?.[vid] || "")
  //     .join(", ");

  //   const h10_100km = vehicleIds
  //     .map((vid) => item["10h_100km"]?.[vid] || "")
  //     .join(", ");

  //   const extraKm = vehicleIds
  //     .map((vid) => item.extra_km?.[vid] || "")
  //     .join(", ");

  //   const extraHr = vehicleIds
  //     .map((vid) => item.extra_hr?.[vid] || "")
  //     .join(", ");

  //   const prime = vehicleIds
  //     .map((vid) => {
  //       const val = item.prime?.[vid];
  //       return val ? `${val}%` : "";
  //     })
  //     .join(", ");
  //   return {
  //     "SI.No": itemIndex + 1,
  //     City: item.city,
  //     "Vehicle Type": vehicleTypes,
  //     // "4H 40KM": h4_40km,
  //     // "6H 60KM": h6_60km,
  //     "8H 80KM": h8_80km,
  //     "10H 100KM": h10_100km,
  //     "Extra KM": extraKm,
  //     "Extra HR": extraHr,
  //     Prime: prime,
  //     Status: item.is_active == 0 ? "Inactive" : "Active",
  //   };
  // });

  // console.log("data to export", updatedData);

  const updatedData = [];

  data?.data?.forEach((item, itemIndex) => {
    const vehicleIds = item.vehicle_type_id || [];
    const vehicleNames = item.vehicle_type_names || {};

    vehicleIds.forEach((vid, vehicleIndex) => {
      const primeValue = item.prime?.[vid];

      updatedData.push({
        // City details: show only on the first vehicle row
        "S.No.": vehicleIndex === 0 ? itemIndex + 1 : "",
        ID: vehicleIndex === 0 ? (item.id ?? "") : "",
        "City ID": vehicleIndex === 0 ? (item.city_id ?? "") : "",
        City: vehicleIndex === 0 ? (item.city ?? "") : "",

        // Vehicle details
        "Vehicle ID": vid,
        "Vehicle Type": vehicleNames[vid] || vid,

        // Hour rental prices
        // "4H 40KM": item["4h_40km"]?.[vid] ?? "",
        // "6H 60KM": item["6h_60km"]?.[vid] ?? "",
        "8H 80KM": item["8h_80km"]?.[vid] ?? "",
        "10H 100KM": item["10h_100km"]?.[vid] ?? "",

        // Additional charges
        "Extra KM": item.extra_km?.[vid] ?? "",
        "Extra HR": item.extra_hr?.[vid] ?? "",

        // Prime percentage
        Prime:
          primeValue !== undefined && primeValue !== null && primeValue !== ""
            ? `${primeValue}%`
            : "",

        // Status
        Status: item.is_active == 0 ? "Inactive" : "Active",
      });
    });
  });

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <HourRentalBasicRateDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={hourRentalBasicRateRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitHourRentalBasicRate}
                  />
                </div>

                {hideAdd && (
                  <div className="w-56">
                    <Button
                      onClick={toggleDrawer}
                      className="w-full rounded-md h-10"
                    >
                      <span className="mr-3">
                        <FiPlus />
                      </span>
                      Add Hour Rental Rate
                    </Button>
                  </div>
                )}

                {hideExport && (
                  <div className="items-center">
                    <RentalExportDataXlsx
                      exportDataXlsx={updatedData}
                      fileNames="Hour Rental Basic Rate"
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData.length ? (
              <TableContainer className="mb-4">
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <TableRow>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        {/* <TableCell>4H 40KM</TableCell>
												<TableCell>6H 60KM</TableCell> */}
                        <TableCell>8H 80KM</TableCell>
                        <TableCell>10H 100KM</TableCell>
                        <TableCell>Extra KM</TableCell>
                        <TableCell>Extra HR</TableCell>
                        <TableCell>Prime</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHeader>
                    <HourRentalBasicRateTable
                      hourRentalBasicRate={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Hour Rental Basic Rates." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default HourRentalBasicRate;
